import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { src: String }

  connect() {
    if (this.element.complete && this.element.naturalWidth === 0) this.replace()
  }

  replace() {
    if (!this.hasSrcValue || this.element.getAttribute("src") === this.srcValue) return

    this.element.src = this.srcValue
  }
}
